"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

require("../styles/_set-due-date.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INITIAL_STATE = {
  date: null,
  comments: '',
  isConfirmModalVisible: false
};

var SetDueDateModal = /*#__PURE__*/function (_Component) {
  _inherits(SetDueDateModal, _Component);

  var _super = _createSuper(SetDueDateModal);

  function SetDueDateModal() {
    var _this;

    _classCallCheck(this, SetDueDateModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", INITIAL_STATE);

    _defineProperty(_assertThisInitialized(_this), "resetState", function () {
      _this.setState(INITIAL_STATE);
    });

    _defineProperty(_assertThisInitialized(_this), "onCommentsChange", function (_ref) {
      var value = _ref.target.value;

      _this.setState({
        comments: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (date) {
      _this.setState({
        date: date
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showConfirmation", function () {
      _this.setState({
        isConfirmModalVisible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeConfirmation", function () {
      _this.setState({
        isConfirmModalVisible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, setDueDate, versionId, outputId, onDueDateChange, onClose, _this$state, date, comments, dueDate, _yield$setDueDate, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, setDueDate = _this$props.setDueDate, versionId = _this$props.versionId, outputId = _this$props.outputId, onDueDateChange = _this$props.onDueDateChange, onClose = _this$props.onClose;
              _this$state = _this.state, date = _this$state.date, comments = _this$state.comments;

              if (date) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              dueDate = date.toISOString();
              _context.next = 7;
              return setDueDate({
                versionId: versionId,
                dueDate: dueDate,
                comments: comments
              });

            case 7:
              _yield$setDueDate = _context.sent;
              data = _yield$setDueDate.data;
              error = _yield$setDueDate.error;

              if (!error) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return");

            case 12:
              onDueDateChange({
                versionId: versionId,
                outputId: outputId,
                dueDate: data.setDueDate
              });
              onClose();

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    return _this;
  }

  _createClass(SetDueDateModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var versionId = this.props.versionId;

      if (!versionId && prevProps.versionId) {
        this.resetState();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          versionId = _this$props2.versionId,
          onClose = _this$props2.onClose;
      var _this$state2 = this.state,
          comments = _this$state2.comments,
          date = _this$state2.date,
          isConfirmModalVisible = _this$state2.isConfirmModalVisible;
      var isFormModalVisible = Boolean(versionId) && !isConfirmModalVisible;
      return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_commonReact.ConfirmationModal, {
          title: "Save Due Date",
          subtitle: "This cannot be undone, are you sure you want to set a fixed due date for the project?",
          visible: Boolean(versionId) && isConfirmModalVisible,
          onSave: this.onSave,
          onClose: this.closeConfirmation
        }), /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
          visible: isFormModalVisible,
          onClose: onClose,
          title: "Why are you changing the due date?",
          onSave: this.showConfirmation,
          saveDisabled: [comments, date].some(function (item) {
            return !item;
          }),
          saveText: "SAVE",
          stayOpenOnSave: true
        }, isFormModalVisible && /*#__PURE__*/_react.default.createElement("div", {
          className: "set-due-date"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
          key: "input-".concat(versionId),
          label: "Comments",
          placeholder: "Comments",
          onChange: this.onCommentsChange,
          rows: 6,
          multiline: true
        }), /*#__PURE__*/_react.default.createElement(_uiKit.DatePicker, {
          key: versionId,
          startDate: date,
          onSelectStartDate: this.onDateChange,
          id: "due-date-picker",
          startLabel: "Date",
          startPlaceholder: "Select new due date",
          displayDateFormat: "DD/MM/YYYY h:mm a",
          enableTime: true
        }))))
      );
    }
  }]);

  return SetDueDateModal;
}(_react.Component);

exports.default = SetDueDateModal;